export const components = {
  emptyState: {
    primaryTitle: 'Ops!',
    primaryText: 'Ainda não há nada aqui…',
    secondaryTitle: 'Nada para mostrar',
    secondaryText: 'Infelizmente, não há itens para exibir com base nos filtros aplicados…'
  },
  filters: {
    all: 'Todos',
    search: 'Buscar',
    priceRange: 'Faixa de preço {currency}',
    minValue: 'O valor mínimo é {val}!',
    maxValue: 'O valor máximo é {val}!',
    reset: 'Redefinir',
    apply: 'Aplicar'
  },
  comments: {
    reply: 'Responder',
    loadMore: 'Carregar mais',
    edited: 'Editado',
    noComments: 'Não há comentários ainda',
    leaveFirstComment: 'Você pode deixar o primeiro'
  },
  curtain: {
    close: 'Fechar'
  },
  photoPreview: {
    close: 'Fechar'
  },
  photoCropper: {
    back: 'Voltar',
    save: 'Salvar'
  },
  rightSidebar: {
    in: 'em'
  },
  pushPrompt: {
    title: '“{appName}” gostaria de enviar notificações para você',
    description: 'As notificações podem incluir alertas, sons e ícones. Estes podem ser configurados nas Configurações.',
    later: 'Perguntar depois',
    neverLater: 'Nunca mais perguntar',
    allow: 'Permitir'
  },
  inAppPush: {
    attachment: 'Anexo'
  },
  installPrompt: {
    android: {
      install: 'Instalar',
      description: 'Para uma experiência contínua, você não precisa usar um navegador. Basta instalá-lo como um aplicativo.',
      press: 'Pressione',
      andSelect: 'e selecione',
      orSimply: 'ou simplesmente',
      description2: 'clique no botão Instalar abaixo',
      notNow: 'Agora não'
    },
    ios: {
      justTap: 'Basta tocar',
      buttonInBrowser: 'botão no seu navegador',
      addToHomeScreen: 'Selecione “Adicionar à tela inicial”',
      appWillBeInstalled: 'O aplicativo será instalado no seu telefone'
    },
    installApp: 'Instalar aplicativo',
    useWeb: 'Usar versão web'
  },
  footer: {
    more: 'Menu'
  },
  menu: {
    installApp: 'Instalar aplicativo',
    menu: 'Menu',
    close: 'Fechar'
  },
  404: {
    whoops: 'Ops!',
    description:
      'Parece que a página não existe ou talvez você não tenha acesso a ela. Por favor, entre em contato com o proprietário do aplicativo para mais detalhes.',
    ok: 'OK'
  },
  relatedUsers: {
    seeall: 'Ver todos'
  },
  networkingCurtain: {
    'newOneOnOne': 'Novo 1:1',
    'details': 'Detalhes',
    'coverMessage': 'Mensagem de capa',
    'location': 'Localização',
    'duration': 'Duração',
    '15min': '15 min',
    '30min': '30 min',
    '45min': '45 min',
    '60min': '60 min',
    'timeSlot': 'Faixa horária',
    'sendInvitation': 'Enviar convite',
    'success': 'Sucesso',
    'invitationSent':
      'Você enviou com sucesso o convite para a reunião 1:1. Deseja permanecer nesta página ou navegar para todas as suas reuniões 1:1 agendadas?',
    'seeAll': 'Ver todas as reuniões 1:1',
    'stayHere': 'Ficar aqui'
  },
  networking: {
    level: {
      1: 'Ainda não pronto para fazer networking. Nenhuma atividade ou envolvimento significativo.',
      2: 'Raramente ativo ou falta informações-chave no perfil, tornando difícil para os outros se conectarem.',
      3: 'Perfil completo com foto e online, totalmente preparado para começar a fazer networking.',
      4: 'Criando momento - iniciou pelo menos uma conexão nas últimas 6 horas.',
      5: 'Mestre do networking - responde ativamente a solicitações e se envolve com os outros nas últimas 6 horas.'
    }
  },
  time: {
    days: 'd',
    hours: 'h',
    minutes: 'm',
    seconds: 's',
    startsIn: 'em',
    Today: 'Hoje',
    today: 'hoje',
    Tomorrow: 'Amanhã',
    tomorrow: 'amanhã',
    Yesterday: 'Ontem',
    yesterday: 'ontem',
    startingNow: 'começando agora'
  },
  daysMonths: {
    months: "['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro']",
    monthsShort: "['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']",
    weekdays: "['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado']",
    weekdaysShort: "['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']",
    weekdaysMin: "['D', 'S', 'T', 'Q', 'Q', 'S', 'S']"
  },
  badges: {
    legend: 'Legendary Networker',
    push: 'Online and Trusted',
    leader: 'Leaderboard Champ',
    meetmaster: '1:1 Meeting Master',
    connector: '3-Time Connector',
    legend_description: 'Alcançar o nível Lenda pelo menos uma vez, fazendo networking ativo e criando conexões significativas.',
    push_description: 'Ative as notificações push para permanecer responsivo e nunca perder uma oportunidade.',
    leader_description: 'Fique pelo menos uma vez entre os 10% melhores da classificação.',
    meetmaster_description: 'Inicie ou responda a pelo menos um pedido de reunião 1:1 no aplicativo.',
    connector_description: 'Estabeleça pelo menos três conexões por meio do aplicativo durante os componentes.'
  }
}
